import { Injectable, EventEmitter } from '@angular/core';
import { ModalPopupService } from '@app/main/cablepro/modal-popup.service';
import { Title } from '@node_modules/@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@node_modules/@angular/router';
import { SwUpdate } from '@node_modules/@angular/service-worker';
import { BehaviorSubject, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventEmitterService {

  invokeFirstComponentFunction = new EventEmitter();
  invokeFirstComponentFunction1 = new EventEmitter();
  subsVar: Subscription;
  subsVar1: Subscription;

  private messageSource = new BehaviorSubject('default message');
  currentMessage = this.messageSource.asObservable();

  constructor() { }
  changeMessage(message: string) {
    this.messageSource.next(message)
  }
  unSubscribe() {
    this.currentMessage = new BehaviorSubject('default message');
    this.invokeFirstComponentFunction = new EventEmitter();
    this.invokeFirstComponentFunction1 = new EventEmitter();
    this.subsVar = undefined;
    this.subsVar1 = undefined;
    // this.messageSource.unsubscribe();
  }
  onFirstComponentButtonClick() {
    this.invokeFirstComponentFunction.emit();
  }
  onFirstComponentButtonClick1() {
    this.invokeFirstComponentFunction1.emit();
  }
}

@Injectable({ providedIn: 'root' })
export class PwaInstallService {
  deferredPrompt: any = null;
  canInstall: boolean | undefined = false;

  constructor(private swUpdate: SwUpdate, private _modalPopupService: ModalPopupService) {
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      this.deferredPrompt = e;
      this.canInstall = true;
    });

    window.addEventListener('appinstalled', (e) => {
      let context = this.getContext();
      this.canInstall = false;
    });

    if (this.swUpdate.isEnabled && this.isInStandaloneMode()) {
      this.swUpdate.versionUpdates.subscribe(event => {
        if (event.type === 'VERSION_READY') {
          this.doAppUpdate();
        }
      });
    }
  }

  private doAppUpdate() {
    this.swUpdate.activateUpdate().then(() => {
      document.location.reload();
    });
  }

  isMobile(): boolean {
    const ua = navigator.userAgent || navigator.vendor || (window as any).opera;
    return /android|iphone|ipad|iPod|opera mini|iemobile|mobile/i.test(ua);
  }

  canPromptInstall(): boolean {
    return !!this.deferredPrompt;
  }

  async promptInstall(): Promise<boolean> {
    if (!this.deferredPrompt) return false;

    this.deferredPrompt.prompt();
    const { outcome } = await this.deferredPrompt.userChoice;
    this.deferredPrompt = null; // reset after use
    return outcome === 'accepted';
  }

  getContext(): { browser: string; device: string; os: string } {
    const userAgent = navigator.userAgent.toLowerCase();

    // --- detect browser ---
    let browser: string;
    if (/chrome|chromium|crios/i.test(userAgent) && !/edg/i.test(userAgent)) {
      browser = 'chrome';
    } else if (/edg/i.test(userAgent)) {
      browser = 'edge';
    } else if (/safari/i.test(userAgent) && !/chrome/i.test(userAgent)) {
      browser = 'safari';
    } else if (/firefox|fxios/i.test(userAgent)) {
      browser = 'firefox';
    } else {
      browser = 'other';
    }

    // --- detect OS ---
    let os: string;
    if (/iphone|ipad|ipod/i.test(userAgent)) {
      os = 'ios';
    } else if (/android/i.test(userAgent)) {
      os = 'android';
    } else if (/windows nt/i.test(userAgent)) {
      os = 'windows';
    } else if (/macintosh|mac os x/i.test(userAgent)) {
      os = 'macos';
    } else if (/linux/i.test(userAgent)) {
      os = 'linux';
    } else {
      os = 'other';
    }

    // --- detect device ---
    const device = /iphone|ipad|ipod|android/i.test(userAgent) ? 'mobile' : 'desktop';

    return { browser, device, os };
  }

  isInStandaloneMode(): boolean {
    return window.matchMedia('(display-mode: standalone)').matches || (window.navigator as any).standalone === true; // for iOS
  }

}


@Injectable()
export class FixedStandaloneTitleStrategy extends TitleStrategy {
  constructor(private readonly title: Title) {
    super();
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    if (this.isStandalone()) {
      // 👇 Always fixed in standalone mode
      this.title.setTitle('ELEK Cable Pro Web');
    } else {
      // 👇 Fallback to normal Angular route titles in browser
      // super.updateTitle(snapshot);
    }
  }

  private isStandalone(): boolean {
    return window.matchMedia('(display-mode: standalone)').matches
        || (navigator as any).standalone === true;
  }
}